import type { ElementType, FC } from 'react';
import { Link } from 'wouter';

import type { ActionUrlTarget } from 'api/banner';
import { getMediaUrl } from 'utils/assets';
import { hasDomainName } from 'utils/hasDomainName';

import styles from './Slider.module.scss';

type BannerSliderItemProps = {
  actionUrl?: string;
  actionUrlTarget: ActionUrlTarget;
  imageUrl: string;
  description?: string;
  onClick?: (event: MouseEvent) => void;
};

const BannerSliderItem: FC<BannerSliderItemProps> = ({
  actionUrl,
  actionUrlTarget,
  description,
  imageUrl,
  onClick,
}) => {
  let Tag: ElementType = 'div';
  let props = {};

  if (actionUrl) {
    Tag = 'a';
    props = { href: actionUrl, target: actionUrlTarget };

    if (!hasDomainName(actionUrl) && actionUrlTarget !== '_blank') {
      Tag = Link;
      props = { to: actionUrl };
    }
  }

  return (
    <Tag {...props} className={styles.slide} onClick={onClick}>
      <img src={`${getMediaUrl(imageUrl, 'cms')}`} alt="" />
      {description && (
        <div className={styles['slider-description']}>{description}</div>
      )}
    </Tag>
  );
};

export default BannerSliderItem;
